import { render, staticRenderFns } from "./BusinessMenuContent.vue?vue&type=template&id=2359a5c0&scoped=true&"
import script from "./BusinessMenuContent.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenuContent.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenuContent.vue?vue&type=style&index=0&id=2359a5c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2359a5c0",
  null
  
)

export default component.exports